import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Easing, animation, filterAnimationValue, returnAnimationValueDelta } from "../../../../utils/animations";
import { FrameSwitcherControl } from "./Control";
var animationGenerator = function animationGenerator(distance, duration) {
  var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Easing.ease;
  return returnAnimationValueDelta(filterAnimationValue(Math.floor, animation(distance, duration, easing)));
};

/**
 * This component extends `FrameSwitcherControl` and add change animation for scroll
 * controls
 * @class
 * @augments FrameSwitcherControl
 */
export var FrameSwitcherAnimated = /*#__PURE__*/function (_FrameSwitcherControl) {
  _inherits(FrameSwitcherAnimated, _FrameSwitcherControl);
  var _super = _createSuper(FrameSwitcherAnimated);
  function FrameSwitcherAnimated() {
    var _this;
    _classCallCheck(this, FrameSwitcherAnimated);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    /**
     * Animation ID used for `requestAnimationFrame` and `cancelAnimationFrame`
     * @type {number}
     */
    _defineProperty(_assertThisInitialized(_this), "animationId", null);
    /**
     * Timeout ID used by autoswitch animation
     * @type {number}
     */
    _defineProperty(_assertThisInitialized(_this), "autoSwitchId", null);
    return _this;
  }
  _createClass(FrameSwitcherAnimated, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(FrameSwitcherAnimated.prototype), "componentDidMount", this).call(this);
      this.startAutoSwitch();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _get(_getPrototypeOf(FrameSwitcherAnimated.prototype), "componentWillUnmount", this).call(this);
      this.stopAutoSwitch();
      this.cancleActiveAnimation();
    }

    // Add stop animation hook to control functions
  }, {
    key: "showSlide",
    value: function showSlide() {
      var _get2;
      this.stopAutoSwitch();
      for (var _len2 = arguments.length, rest = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        rest[_key2] = arguments[_key2];
      }
      (_get2 = _get(_getPrototypeOf(FrameSwitcherAnimated.prototype), "showSlide", this)).call.apply(_get2, [this].concat(rest));
    }
  }, {
    key: "showLeft",
    value: function showLeft() {
      var _get3;
      this.stopAutoSwitch();
      for (var _len3 = arguments.length, rest = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        rest[_key3] = arguments[_key3];
      }
      (_get3 = _get(_getPrototypeOf(FrameSwitcherAnimated.prototype), "showLeft", this)).call.apply(_get3, [this].concat(rest));
    }
  }, {
    key: "showRight",
    value: function showRight() {
      var _get4;
      this.stopAutoSwitch();
      for (var _len4 = arguments.length, rest = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        rest[_key4] = arguments[_key4];
      }
      (_get4 = _get(_getPrototypeOf(FrameSwitcherAnimated.prototype), "showRight", this)).call.apply(_get4, [this].concat(rest));
    }

    /**
     * Animate scroll to end point
     * @param {number} position Scroll position to scroll to
     * @param {*} rest Other arguments used in `FrameSwitcherAnimated.moveBy` method
     */
  }, {
    key: "moveTo",
    value: function moveTo(position) {
      for (var _len5 = arguments.length, rest = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        rest[_key5 - 1] = arguments[_key5];
      }
      return this.moveBy.apply(this, [position - this.scroll].concat(rest));
    }

    /**
     * Animate scroll by given amount of px
     * @param {number} delta Amount of px to scroll
     * @param {number} duration Duration of animation
     * @param {(time: number) => number} easing Easing function to use in animation
     */
  }, {
    key: "moveBy",
    value: function moveBy(delta) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.transitionDuration;
      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Easing.ease;
      if (duration === 0) {
        return Promise.resolve(_get(_getPrototypeOf(FrameSwitcherAnimated.prototype), "moveBy", this).call(this, Math.floor(delta)));
      }
      return this.handleAnimationPromise(animationGenerator(Math.floor(delta), duration, easing));
    }

    /**
     * Switches frame by delta. It uses `this.move` function to change frame. It won't be executed
     * if any animation in progress already
     * @param {number} delta Direction and amount of frames to scroll throught
     */
  }, {
    key: "changeFrame",
    value: function changeFrame(delta) {
      if (this.animationId) {
        return Promise.resolve();
      }
      return _get(_getPrototypeOf(FrameSwitcherAnimated.prototype), "changeFrame", this).call(this, delta);
    }
  }, {
    key: "handleAnimation",
    value:
    /**
     * Applies changes of animation function
     * @param {() => {value: number, done: boolean}} changeFn Animation function
     * @param {() => void} onFinish Callback to execute after animation end
     */
    function handleAnimation(changeFn) {
      var _this2 = this;
      var onFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      this.cancleActiveAnimation();
      var _changeFn = changeFn(),
        value = _changeFn.value,
        done = _changeFn.done;
      this.scrollBy(value);
      if (!done) {
        this.animationId = requestAnimationFrame(function () {
          return _this2.handleAnimation(changeFn, onFinish);
        });
      } else {
        requestAnimationFrame(onFinish);
      }
    }

    /**
     * Promisified version of `FrameSwitcherAnimated.handleAnimation`
     * @param {() => {value: number, done: boolean}} changeFn Animation function
     */
  }, {
    key: "handleAnimationPromise",
    value: function handleAnimationPromise(changeFn) {
      var _this3 = this;
      return new Promise(function (resolve) {
        return _this3.handleAnimation(changeFn, resolve);
      });
    }

    /**
     * Stop animation hook
     */
  }, {
    key: "cancleActiveAnimation",
    value: function cancleActiveAnimation() {
      cancelAnimationFrame(this.animationId);
      this.animationId = null;
    }
  }, {
    key: "startAutoSwitch",
    value:
    /**
     * Hook to start autoswitch animation
     */
    function startAutoSwitch() {
      var _this4 = this;
      if (this.props.autoSwitchTime) {
        this.autoSwitchId = setTimeout(function () {
          var _this4$props = _this4.props,
            cycle = _this4$props.cycle,
            framesPerSlide = _this4$props.framesPerSlide,
            frames = _this4$props.frames;
          var activeFrame = _this4.state.activeFrame;
          if (cycle || activeFrame < frames.length - framesPerSlide) {
            _this4.showRight();
            _this4.startAutoSwitch();
          }
        }, this.props.autoSwitchTime);
      }
    }

    /**
     * Hook to stop autoswitch animation
     */
  }, {
    key: "stopAutoSwitch",
    value: function stopAutoSwitch() {
      clearTimeout(this.autoSwitchId);
      this.autoSwitchId = null;
    }
  }]);
  return FrameSwitcherAnimated;
}(FrameSwitcherControl);